export const LANGUAGES = {
  EN: 'en',
  DE: 'de',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  PL: 'pl',
  RO: 'ro',
  CZ: 'cz',
  NL: 'nl',
  TR: 'tr',
  UK: 'uk',
  SK: 'sk',
  ZZ: 'zz',
} as const;

export type Language = (typeof LANGUAGES)[keyof typeof LANGUAGES];
